import React, { Component } from 'react';
import moment from 'moment';

import { Icon, message } from 'antd';
import CommonForm from '@common/components/form';
import ComuniService from '@common/services/locations/Comuni';

import accreditamentoStatic from '@common/utils/static/accreditamento';

import formatter from '@common/utils/formatters/_';

const formLayout = (component) => {
  return {
    layout: 'vertical',
    multistep: false,
    rows: [
      {
        cols: [
          {
            items: [
              {
                name: 'titolo_profilo',
                type: 'title',
                element: 'h4',
                text: component.props.stato_non_statico == accreditamentoStatic.stato.accolta_e_confermata ? 'Nuovo Rappresentante legale' : 'Precedente Rappresentante legale',
                props: {
                  style: { textAlign: 'left' },
                  className: 'm10h'
                },
              },
            ],
          },
        ],
      },
      {
        cols: [
          {
            items: [
              {
                type: 'input',
                label: 'Nome',
                type_string: 'text', // field type
                name: 'nome',
                props: {
                  //size: 'large',
                  disabled: true,
                  prefix: <Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />,
                },
              },
            ],
          },
          {
            items: [
              {
                type: 'input',
                label: 'Cognome',
                type_string: 'text', // field type
                name: 'cognome',
                props: {
                  // size: 'large',
                  disabled: true,
                  prefix: (
                    <Icon type="solution" style={{ color: 'rgba(0,0,0,.25)' }} />
                  ),
                },
              },
            ],
          },
        ],
      },
      {
        cols: [
          {
            span: 6,
            items: [
              {
                type: 'datepicker',
                label: 'Data di nascita',
                name: 'nato_il',
                format: 'DD/MM/YYYY',
                props: {
                  // size: 'large',
                  style: { width: '100%' },
                  disabled: true,
                },
              },
            ],
          },
          {
            span: 6,
            items: [
              {
                type: 'select',
                label: 'Stato di nascita',
                name: 'stato_nascita',
                props: {
                  //size: 'large',
                  showSearch: true,
                  disabled: true,
                  filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                options_props: 'nazioni',
                onChange: 'selectedStato',
              },
            ],
          },
          {
            span: 6,
            items: [
              {
                type: 'select',
                label: 'Provincia di nascita',
                name: 'provincia_nascita',
                props: {
                  showSearch: true,
                  disabled: true,
                  filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'stato_nascita',
                    operator: '==',
                    value: 1,
                  },
                ],
                options_props: 'province',
                onChange: 'selectedNascitaProvincia',
              },
            ],
          },
          {
            span: 6,
            items: [
              {
                type: 'select',
                label: 'Comune di nascita',
                name: 'comune_nascita',
                props: {
                  showSearch: true,
                  disabled: true,
                  filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                showIf: [
                  {
                    type: 'field_validation',
                    field: 'provincia_nascita',
                    operator: '!=',
                    value: null,
                  },
                  {
                    type: 'field_validation',
                    field: 'stato_nascita',
                    operator: '==',
                    value: 1,
                  },
                ],
                options_props: 'comuni'
              },
            ],
          }
        ],
      },
      {
        cols: [
          {
            span: 12,
            items: [
              {
                type: 'input',
                label: 'Codice fiscale',
                type_string: 'text', // field type
                name: 'cf',
                props: {
                  // size: 'large',
                  prefix: <Icon type="copy" style={{ color: 'rgba(0,0,0,.25)' }} />,
                  disabled: true,
                },
              },
            ],
          },
          {
            span: 12,
            items: [
              {
                type: 'input',
                label: 'Telefono',
                type_string: 'text', // field type
                name: 'telefono',
                props: {
                  // size: 'large',
                  prefix: <Icon type="copy" style={{ color: 'rgba(0,0,0,.25)' }} />,
                  disabled: true,
                },
              },
            ],
          }
        ],
      },

      {
        cols: [
          {
            span: 24,
            items: [
              {
                label: <>Data fine validità: {component.props.data_fine_attivita}</>,
                name: 'simple_label_1',
                type: 'simple_label'  ,
                showIf: [
                  {
                    type: "prop_func",
                    func: "domandaNonAccolta",
                  },
                ],
              },
            ],
          },
          {
            span: 24,
            items: [
              {
                label: <>Data inizio validità: {moment(component.props.accreditamento.storicoRL.data_inizio_validita).format("DD/MM/YYYY")}</>,
                name: 'simple_label_1',
                type: 'simple_label' ,
                showIf: [
                  {
                    type: "prop_func",
                    func: "domandaAccolta",
                  }, 
                ]
              },
            ],
          },

          component.props.accreditamento.storicoRL.autodichiarazione ? {
            span: 24,
            items: [
              {
                label: <>I termini per il cambio del Rappresentante legale sono stati accettati in data: {moment(component.props.accreditamento.storicoRL.data_accettazione_autodichiarazione).format("DD/MM/YYYY")}</>,
                name: 'simple_label_2',
                type: 'simple_label'  ,
                showIf: [
                  {
                    type: "prop_func",
                    func: "domandaAccolta",
                  }, 
                ] 
              },
            ],
          } : {
            span: 24,
            items: [
              {
                label: <b>Il Rappresentante legale non ha ancora accettato i termini per il cambio</b>,
                name: 'simple_label_3',
                type: 'simple_label'  ,
                showIf: [
                  {
                    type: "prop_func",
                    func: "domandaAccolta",
                  }, 
                ]
              },
            ],
          },
          
        ],
      },
      
    ],
    onSubmit: 'submitted',
  }
}

class DatiPrecedenteRL extends Component {
  state = {
    loading: true,
    loaded: false,
    comuni: [],
    files: {}
  };



  async componentDidMount() {

    //if (this.props.values) this.setFileInState(this.props);
    this.loadComuni(this.props)
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.accreditamento.id !== this.props.accreditamento.id) this.loadComuni(newProps)
  }

  loadComuni(props) {
    if (props.rappresentanteLegale.provincia_nascita) {
      this.selectedProvincia(props.rappresentanteLegale.provincia_nascita)
    } else {
      this.setState({ loading: false });

      if (this.props.loadingComuni) {
        this.props.loadingComuni(false);
      }
    }
  }

  selectedProvincia(provincia) {

    this.setState({ loading: true });


    ComuniService.all(
      {
        id_provincia: provincia
      },
      res => {

        this.setState({
          loading: false,
          comuni: res.data.data || [],
          selected_nascita_provincia: provincia
        });
      },
      () => {
        this.setState({ loading: false });
      }
    );
  }

  getFormData() {
    return formatter.replaceFormDatesOut(['nato_il'], this.formRefDatiRappr.props.form.getFieldsValue());
  }

  getValues() {
    try {
      return formatter.replaceFormDatesIn(['nato_il'], {
        ...this.props.rappresentanteLegale,
        telefono: this.props.rappresentanteLegale.contatti && this.props.rappresentanteLegale.contatti.length > 0 ? this.props.rappresentanteLegale.contatti[0]['telefono'] : '',
      })
    } catch (e) {
      return formatter.replaceIntegeresWithString(['comune_nascita'], this.props.rappresentanteLegale);
    }
  }

  render() {

    return (
      <div>
        <CommonForm
          wrappedComponentRef={inst => (this.formRefDatiRappr = inst)}
          loading={this.props.loading || false}
          form_model={formLayout(this)}
          values={
            this.getValues()
          }

          nazioni={this.props.GlobalStore.stubs.nazione}
          province={this.props.GlobalStore.stubs.provincia}

          readOnly={this.props.readOnly}

          selectedStato={() => {
            //console.log (this.formRefDatiRappr.props.form);
            this.setState({
              comuni: [],
            }, () => {
              this.formRefDatiRappr.props.form.setFieldsValue({ comune_nascita: null, provincia_nascita: null });
            });
          }}

          selectedNascitaProvincia={data => {
            //console.log (this.formRefDatiRappr.props.form);

            this.setState({
              selected_nascita_provincia: data,
              comuni: [],
              loading: true,
            }, () => {
              this.formRefDatiRappr.props.form.setFieldsValue({ comune_nascita: null })
              this.selectedProvincia(data);
            });
          }}

          comuni={this.state.comuni.map(e => {
            return {
              key: 'residenza_comune_' + e.id,
              value: e.id,
              label: e.comune
            }
          })}

          domandaAccolta={() => {
            return this.props.stato_non_statico == accreditamentoStatic.stato.accolta_e_confermata
          }}

          domandaNonAccolta={() => {
            return this.props.stato_non_statico != accreditamentoStatic.stato.accolta_e_confermata
          }}

        />
      </div>
    );
  }
}

export default DatiPrecedenteRL;